export const themeColors = [
  '#ffffff',
  '#f2f2f2',
  '#d8d8d8',
  '#bfbfbf',
  '#a5a5a5',
  '#7f7f7f',
  '#000000',
  '#808080',
  '#5a5a5a',
  '#404040',
  '#272727',
  '#0d0d0d',
  '#eeece1',
  '#ddd9c3',
  '#c5be97',
  '#948b54',
  '#4a452a',
  '#1d1b11',
  '#1f497d',
  '#c5d9f1',
  '#8db4e3',
  '#538ed5',
  '#17375d',
  '#0f253f',
  '#4f81bd',
  '#dbe5f1',
  '#b8cce4',
  '#95b3d7',
  '#376091',
  '#254061',
  '#c0504d',
  '#f2dddc',
  '#e6b9b8',
  '#d99795',
  '#953735',
  '#632523',
  '#9bbb59',
  '#eaf1dd',
  '#d7e4bc',
  '#c2d69a',
  '#75923c',
  '#4f6228',
  '#8064a2',
  '#e5e0ec',
  '#ccc0da',
  '#b2a1c7',
  '#60497b',
  '#3f3151',
  '#4bacc6',
  '#dbeef3',
  '#b6dde8',
  '#93cddd',
  '#31849b',
  '#215867',
  '#f79646',
  '#fde9d9',
  '#fcd5b4',
  '#fac090',
  '#e46d0a',
  '#974807',
];

export const standardColors = [
  '#c00000',
  '#ff0000',
  '#ffc000',
  '#ffff00',
  '#92d050',
  '#00b050',
  '#00b0f0',
  '#0070c0',
  '#002060',
  '#7030a0',
];
